import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, RefreshCw } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

export const PaymentFailed = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    toast({
      variant: "destructive",
      title: "Ödeme Başarısız",
      description: "Lütfen kart bilgilerinizi kontrol edip tekrar deneyiniz.",
    });
  }, [toast]);

  return (
    // ARKA PLAN: Ödeme sayfasıyla aynı modern koyu gradyan
    <div className="min-h-screen bg-gradient-to-br from-[#4F46E5] via-[#3730A3] to-[#1E293B] flex items-center justify-center p-4">

      {/* KART: Cam efekti ve beyaz yazı teması */}
      <Card className="w-full max-w-md bg-slate-900/60 border-white/10 backdrop-blur-xl shadow-2xl text-white">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-6">
            <div className="relative">
              {/* İkon arkasında hafif bir kırmızı parlama */}
              <div className="absolute inset-0 bg-rose-500/20 blur-2xl rounded-full"></div>
              <XCircle className="w-20 h-20 text-rose-500 relative z-10 animate-pulse" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold text-white">Ödeme Başarısız</CardTitle>
        </CardHeader>

        <CardContent className="text-center space-y-8 pt-4">
          <p className="text-slate-300 text-lg leading-relaxed">
            Üzgünüz, ödeme işlemi bankanız tarafından reddedildi veya bir hata oluştu. Lütfen bilgilerinizi kontrol ederek tekrar deneyin.
          </p>

          <div className="space-y-3">
            {/* ANA BUTON: Indigo rengi */}
            <Button
              onClick={() => navigate("/payment")}
              className="w-full bg-[#4F46E5] hover:bg-[#4338CA] text-white h-14 text-lg font-bold shadow-lg shadow-indigo-500/20 transition-all flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-5 h-5" />
              Tekrar Dene
            </Button>

            {/* İKİNCİL BUTON: Şeffaf stil */}
            <Button
              variant="ghost"
              onClick={() => navigate("/coaches")}
              className="w-full text-slate-400 hover:text-white hover:bg-white/5 transition-colors"
            >
              Mentör Listesine Dön
            </Button>
          </div>

          <div className="pt-4 border-t border-white/5">
            <p className="text-xs text-slate-500 uppercase tracking-widest">
              Sorun devam ederse: info@kampusmentorluk.com
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentFailed;